module.exports = __webpack_public_path__ + "img/img-title.9e8005ea.png";